import { useForm } from "react-hook-form";
import { registroFacturas } from "../types";
import { yupResolver } from "@hookform/resolvers/yup";
import {  newRegistroFactura, ROUTER_PATHS } from "@/shared";
import { useNavigate } from "react-router-dom";
import { useFetchBodegas, useFetchGetIngresarProducto, useFetchIvas,  useFetchPaymentMethodsParamsProveedor, usefetchProveedor, useFetchTipoComprobantes, useFetchUbicaciones } from "@/shared/actions/erp";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import { useGastos } from "@/store/erp/gastos/useGastos";

import { MaterialTransferido } from "@/shared/interfaces";
import { Gastos } from "@/shared/interfaces/erp/inventario";
import { useCreateRegistroFactura } from "@/shared/actions/erp/registro_factura/registro_factura.actions";
import { toast } from "react-toastify";

const returnUrlRegistroFactura = ROUTER_PATHS.contabilidad.registroFacturaNav
export default function useRegistroFacturas() {
  const producto = useCargarSeriesProductos(s => s.productos)
  const gasto = useGastos(s => s.gastos)
  //console.log('producto', producto)
  const navigate = useNavigate()

  const form = useForm<registroFacturas>({
    resolver: yupResolver(newRegistroFactura),
    defaultValues: {
      es_gasto: false,
      contiene_orden_compra: false,
      es_combinado: false,
    }
  });
  const {
    handleSubmit,
    reset,
    formState: { errors }
  } = form

  /* const {
    data: ordenCompraResp,
    isLoading: isLoadingOrdenCompra
  } = useFetchOrdenesCompras({
    page_size: 600,
    estado_orden: EstadosProcesoEnumChoice.PARCIAL
    //estado_orden_in: `${EstadosProcesoEnumChoice.FINALIZADO},${EstadosProcesoEnumChoice.PARCIAL}`
  }) */
  const {
    data: ingresoInventarioResp,
    isLoading: isLoadingIngresoInventario
  } = useFetchGetIngresarProducto({
    enabled: true,
    params: {
      page_size: 600,
      orden_compra_isnull: false
    }
  })

  const {
    data: BodegaRes,
    isLoading: isLoadinBodega
  } = useFetchBodegas({
    page_size: 600
  })

  const {
    data: ubicacionesResp,
    isLoading: isLoadingUbicacion
  } = useFetchUbicaciones({
    page_size: 600
  })

  const {
    data: proveedorResp,
    isLoading: isLoadingProveedor
  } = usefetchProveedor({
    page_size: 600
  })

  const {
    data: TipoComprobantePaging,
    isLoading: isLoadingTipoComprobante
  } = useFetchTipoComprobantes({
    enabled: true,
    params: {
      page_size: 600
    }
  })

  const {
    data: formaPagoProveedorResp,
    isLoading: isLoadingFormaPagoProveedor
  } = useFetchPaymentMethodsParamsProveedor({
    page_size: 600
  })

  const {
    data: ivaResp,
    isLoading: isLoadinIva
  } = useFetchIvas({
    page_size: 600
  })


  ///mutations
  const createRegistroFactura = useCreateRegistroFactura({
    navigate,
    returnUrl: returnUrlRegistroFactura
  })

  //console.log('handle', handleUploadFile)

  const onSave = () => {
   
    const { descripcion_otro, costo_otro, iva_otro_porcentaje, iva_otro, total_otro, ...rest } = form.getValues()

    const productosInValidos = producto.find(item => Number(item.precio_compra) <= 0)
   
    if (productosInValidos) {
      return toast.error(`El producto "${productosInValidos.codigo}" tiene valor unitario  de cero. Ingrese un valor válido.`)
    }
    const codigoOrdenCompra = ingresoInventarioResp?.data.data.find(item => item.codigo === form.getValues().orden_compra)
    
    let detalles: (MaterialTransferido | Gastos)[] = []
    if (form.getValues().es_combinado) {
      detalles = [
        ...(producto ?? []),
        ...(gasto ?? [])
      ]
    } else {
      detalles = (producto && producto.length > 0) ? producto
        : (gasto && gasto.length > 0) ? gasto : []
    }
    //console.log('destalles', detalles)

    if (!detalles.length) return toast.error('Seleccione al menos un producto.')

    //if(detalles.find())

    const registroFactura = {
      ...rest,
      orden_compra:codigoOrdenCompra?.orden_compra,
      detalles: detalles,
      otros_impuesto: [{
        descripcion_otro,
        costo_otro,
        iva_otro_porcentaje,
        iva_otro,
        total_otro
      }]
    }
    /* console.log('resgistro', registroFactura)
    return; */
    return createRegistroFactura.mutate(registroFactura)
  }

  return {
    form, navigate, handleSubmit,
    errors, reset,
    ingresoInventarioResp, isLoadingIngresoInventario,
    //ordenCompraResp, isLoadingOrdenCompra,
    BodegaRes, isLoadinBodega,
    ubicacionesResp, isLoadingUbicacion,
    proveedorResp, isLoadingProveedor,
    TipoComprobantePaging, isLoadingTipoComprobante,
    formaPagoProveedorResp, isLoadingFormaPagoProveedor,
    ivaResp, isLoadinIva, onSave
  }

}